import i18n from "../i18n";

/**
 * Format a number as currency, using the user's selected language.
 * @param {number} amount
 * @param {string} [currency='EUR']
 * @param {string} [locale] - Optional, defaults to i18n.language or browser
 * @returns {string}
 */
export function formatCurrency(amount, currency = "EUR", locale) {
    const lang = locale || i18n.language || navigator.language || "en-GB";
    return new Intl.NumberFormat(lang, { style: "currency", currency }).format(amount);
}

// Validate allocation amount
export function isValidAllocation(amount, min = 1000, max = 1000000) {
    return typeof amount === "number" && amount >= min && amount <= max;
}

// Calculate user share in a distribution
export function calculateUserShare(userAmount, totalAmount, distribution) {
    if (totalAmount === 0) return 0;
    return (userAmount / totalAmount) * distribution;
}